/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListAIDetectionUsersSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListAIDetectionUsersRequest = {
  /**
   * Id of the detection target to expand. Accepted exactly as agents report it, under the same length bound the scan-report ingest stores it with, so every id in the inventory can be expanded.
   */
  targetId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListAIDetectionUsersSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAIDetectionUsersSecurity$outboundSchema: z.ZodMiniType<
  ListAIDetectionUsersSecurity$Outbound,
  ListAIDetectionUsersSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAIDetectionUsersSecurityToJSON(
  listAIDetectionUsersSecurity: ListAIDetectionUsersSecurity,
): string {
  return JSON.stringify(
    ListAIDetectionUsersSecurity$outboundSchema.parse(
      listAIDetectionUsersSecurity,
    ),
  );
}

/** @internal */
export type ListAIDetectionUsersRequest$Outbound = {
  target_id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAIDetectionUsersRequest$outboundSchema: z.ZodMiniType<
  ListAIDetectionUsersRequest$Outbound,
  ListAIDetectionUsersRequest
> = z.pipe(
  z.object({
    targetId: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      targetId: "target_id",
      gramSession: "Gram-Session",
    });
  }),
);

export function listAIDetectionUsersRequestToJSON(
  listAIDetectionUsersRequest: ListAIDetectionUsersRequest,
): string {
  return JSON.stringify(
    ListAIDetectionUsersRequest$outboundSchema.parse(
      listAIDetectionUsersRequest,
    ),
  );
}
